import React from 'react';
import { node, bool, string, shape } from 'prop-types';

const AdjustableLinkBlock = (props) => {
  if (!props.Content) return false;

  const { Heading, Text, LinkText, LinkUrl } = props.Content;

  return (
    <div className="c-navigationpush">
      {props.useBackgroundImage && (
        <div className="c-navigationpush__bg">
          <div className="c-navigationpush__bg__inner" />
        </div>
      )}
      <div className="c-navigationpush__content">
        {Heading && (
          <h2 className="c-navigationpush__content__heading">{Heading}</h2>
        )}

        {LinkUrl && (
          <p>
            <a href={LinkUrl}>
              {Text}
              {props.useIconLink && <i className="c-navigationpush__icon" />}
            </a>
          </p>
        )}
        {!LinkUrl && <p>{Text}</p>}

        {LinkText && (
          <a className="c-navigationpush__content__link" href={LinkUrl}>
            {LinkText}
          </a>
        )}
      </div>
    </div>
  );
};

AdjustableLinkBlock.propTypes = {
  useBackgroundImage: bool,
  useIconLink: bool,
  Content: shape({
    LinkUrl: string,
    LinkText: node,
    Heading: node,
    Text: node,
  }),
};

export default AdjustableLinkBlock;
